import { collections } from '@/mocks/site';

export default function CollectionSection() {
  return (
    <section id="collections" className="scroll-mt-20 bg-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-primary-600 uppercase">
            <i className="ri-bookmark-3-line"></i> CURATED LISTS
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">编辑精选片单</h2>
          <p className="mt-2 text-sm text-foreground-600">
            不知道看什么？我们从海量资源中按主题整理出几份片单。每一份都附有选片理由，列表中的影片都能在对应分区单独找到。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
          {collections.map((col, i) => (
            <article
              key={col.title}
              className="group rounded-lg border border-background-200 bg-background-50 overflow-hidden transition-all duration-300 hover:border-primary-300 hover:-translate-y-1"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={col.cover}
                  alt={`${col.title} 片单封面`}
                  title={`${col.title} 精选片单`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-50/90 text-foreground-900 text-[11px] font-medium">
                  {col.subtitle}
                </span>
                <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-md bg-accent-500 text-foreground-950 text-[11px] font-semibold">
                  {col.count}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">
                  <span className="text-primary-600 mr-1.5">0{i + 1}</span>
                  {col.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{col.desc}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {col.tags.map((t) => (
                    <span key={t} className="px-2.5 py-1 rounded-full bg-secondary-50 border border-secondary-200 text-xs text-secondary-700">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}